import { CommonModule } from '@angular/common';
import {
  isNullOrEmpty,
  LocalizationService,
  SubscriptionService,
  LocalizationModule,
} from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef, FilterModel } from '@ag-grid-community/core';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { CustomerQuoteListDto, CustomerQuoteService } from '@digiwall/goliath-documents/proxy';
import { BaseCustomerDocList } from '../../base-customer-docs/base-customer-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-quote-list',
  templateUrl: './quote-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class QuoteListComponent
  extends BaseCustomerDocList<CustomerQuoteListDto, CustomerQuoteService>
  implements OnInit
{
  predefinedFilters: FilterModel;

  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'quoteStatusId',
      headerName: this.localizationService.instant('Doc::QuoteStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.quoteStatus,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'versionName',
      headerName: this.localizationService.instant('Doc::CustomerQuote:VersionName'),
      type: FieldTypes.String,
    },
    {
      field: 'versionNumber',
      headerName: this.localizationService.instant('Doc::CustomerQuote:VersionNumber'),
      type: FieldTypes.Number,
    },
    {
      field: 'validityDate',
      headerName: this.localizationService.instant('Doc::CustomerQuote:ValidityDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'estimatedAvailability',
      headerName: this.localizationService.instant('Doc::CustomerQuote:EstimatedAvailability'),
      type: FieldTypes.String,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      if (!isNullOrEmpty(queryParams['thirdParty'])) {
        this.predefinedFilters = {
          thirdPartyCode: { filterType: 'text', type: 'equals', filter: queryParams['thirdParty'] },
          isClosed: { filterType: 'set', values: ['false'] },
        };
      } else if (!isNullOrEmpty(queryParams['thirdPartyCode'])) {
        this.predefinedFilters = {
          thirdPartyCode: {
            filterType: 'text',
            type: 'equals',
            filter: queryParams['thirdPartyCode'],
          },
          isClosed: { filterType: 'set', values: ['false'] },
        };
      }
    });

    super.ngOnInit();
  }

  constructor(
    protected quoteService: CustomerQuoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      quoteService,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
    );
  }

  duplicateQuote() {
    this.quoteService.getAnnexesCount(this.selectedEntities()[0].id).subscribeOnce(count => {
      this.duplicateDoc(count != 0);
    });
  }

  protected override afterDuplicateDialogShown(instance: any): void {
    instance.isPriceComputationAvailable = true;
  }
}
